const styles = (theme) => ({
  container: {
    minHeight:0,
    flexWrap: "nowrap",
    marginTop: 4,
    height: "97%"
  },
  containerWithoutError: {
    height: "100%",
    flexWrap: "nowrap",
    marginTop: 4,
    display : "flex",
    flexDirection : "column"
  },
  topGridContainer: {
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "4px 4px 0 0",
    marginRight: 4,
  },
  bottomGridContainer: { flex: "80%", width: "99%" },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
  },
  headerStyle: {
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontSize: theme.headerTextFontSize,
    color: theme.HeaderSelectedText,
    padding: "6px 10px 6px 10px",
    display: "flex",
    alignItems: "center",
  },

  gridItem: {
    padding: 10,
    display: "flex",
  },
  newDriverClass: {
    fontWeight: "500",
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: "14px",
    color: theme.dispatchPanelLabelValueColor,
  },
  headerLabelStyle: {
    fontWeight: "600",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.dispatchPanelLabelValueColor,
  },
  solutionContainer: {
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  containerStyle: {
    padding : 12,
    width : "unset"
  },
  checkBoxStyle: {
    color: theme.gridIconBorderColor,
    padding: "0px",
    fontSize: 30,
    "&$checked": {
      color: theme.HeaderSelectedText,
      fontSize: 30,
    },
    marginRight : 4
  },
  sizeIcon: {
    fontSize: 24,
  },
  errorBar: {
    border: `1px solid ${theme.gridGroupHeaderBorderColor}`,
    color: theme.gridTextColor,
    padding: "10px",
    borderRadius: "5px",
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: "16px",
    display: "flex",
    alignItems: "center",
  },
  errorBarText: {
    marginLeft: "10px",
  },
  dropdownError: {
    display : "block",
    marginTop : 4,
    fontSize: theme.textFontSize,
    color: theme.ErrorMessageColor,
  },
  iconStyle: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "center",
    paddingRight: "8px",
    paddingTop: 1
  },
  assignShipperDetails: {
    display: "flex",
    paddingLeft:5,
  },
  unassignShipperDetails: {
    display: "flex",
    paddingLeft:5,
    flexDirection: "column"
  },
  assignedDriver: {
    overflow: "auto",
    flex: "0 1 auto",
  },
  minHeightAssignDriver: {
    minHeight: "51px",
  },
  assignedPickup: {
    overflow: "hidden",
  },
  unassignPickupContainer: {
    overflow: "auto",
    flex: "1 2 auto",
  },
  routeMap: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
  },
  expand: {
    backgroundColor: theme.ModalBGColor,
    color: theme.HeaderSelectedText,
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    border: `1px solid ${theme.gridGroupHeaderBorderColor}`,
    borderRadius: 50,
    padding: 5,
  },
  expandMain: {
    backgroundColor: theme.ModalBGColor,
    color: theme.HeaderSelectedText,
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    padding: 5,
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  unassignPickupCheckbox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start"
  },
  assignDriverLabel: {
    fontSize: theme.textFontSize,
    lineHeight: "19px",
    fontWeight: 600,
    marginRight: 8,
    marginLeft: 5,
  },
  assignDriverClass: {
    fontWeight: "500",
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: "14px",
    color: theme.dispatchPanelLabelValueColor,
    display: "flex",
    alignItems: "flex-start",
    flexWrap : "wrap",
    "& > b" : {
      paddingRight:5,
      marginTop : 10
    }
  },
  noData: {
    padding: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
  },
  unAssignHeaderStyle: {
    borderRadius : "4px",
    borderTop: `1px solid ${theme.AppBGColor}`,
  },
  solutionMainContainer : {
    display : "flex",
    padding : 10,
    justifyContent : "space-between"
  },
  checkBoxContainer : {
    display : "flex"
  },
  statusBarGridItem : {
    flexBasis : "unset"
  },
  reactSelect: {
    "& .select__control": {
      minWidth: 180,
    },
  },
});

export default styles;
